module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "l-row"
  }, _vm._l((_vm.levels), function(level, index) {
    return _c('form-group', {
      key: index,
      attrs: {
        "label": ((_vm.$t('category.label')) + " " + (_vm.$t('level.label')) + " " + ((index + 1))),
        "columns": _vm.columns
      }
    }, [_c('select', {
      staticClass: "form-select",
      domProps: {
        "value": _vm.selectedId(index)
      },
      on: {
        "change": function($event) {
          return _vm.onChange(index, $event.target.value)
        }
      }
    }, [_c('option', {
      domProps: {
        "value": null
      }
    }, [_vm._v(_vm._s(_vm.$t('choose.label')))]), _vm._v(" "), _vm._l((level), function(category) {
      return _c('option', {
        key: category.id,
        domProps: {
          "value": category.id
        }
      }, [_vm._v(_vm._s(category.name))])
    })], 2)])
  }), 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-52617b63","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/presets/ecommerce/moovin/marketplace/shein/CategoryCascade.vue
// module id = 3168
// module chunks = 0